export default "__VITE_ASSET__DcFiZkqG__"